import React from 'react';
import { CardsContainer } from '../../ui/CardsLayout/styled';
import { ItemCardSkeletonBody } from '../ItemCardPlaceholder';
import { SkeletonItemCard } from './styled';

interface EndlessItemsPlaceholderProps {
  count: number;
  container?: React.ElementType;
  containerProps?: Record<string, boolean>;
}

export const endlessItemsPlaceholderCards = (count: number) =>
  Array.from({ length: count }, (_, index) => (
    <SkeletonItemCard key={index}>
      <ItemCardSkeletonBody />
    </SkeletonItemCard>
  ));

export const EndlessItemsPlaceholder: React.FC<
  EndlessItemsPlaceholderProps
> = ({ count, container: Container = CardsContainer, containerProps }) => (
  <Container {...containerProps}>
    {endlessItemsPlaceholderCards(count)}
  </Container>
);
